import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { TelephonyComponentsModule } from '../../../telephony-components.module';
import { TelephonyWebhooksComponent } from './telephony-webhooks.component';

const routes: Routes = [
  { path: '', component: TelephonyWebhooksComponent, data: { title: 'Telephony Webhooks' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TelephonyUsersRoutingModule {}

@NgModule({
  imports: [
    TelephonyUsersRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TelephonyComponentsModule,
  ],
  declarations: [TelephonyWebhooksComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TelephonyWebhooksModule {}
